
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.034","height":"21.034"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_1312","data-name":"Path 1312","d":"M17.954 3.08A10.517 10.517 0 003.08 17.954 10.517 10.517 0 0017.954 3.08zm-7.437-1.437A8.878 8.878 0 0118.154 6h-7.637a4.526 4.526 0 00-4.225 2.913L3.831 4.689a8.856 8.856 0 016.686-3.046zm-2.672 9.934a2.874 2.874 0 012.672-3.936h.164A2.876 2.876 0 118 11.915l.027-.016zm1.1 7.674A8.871 8.871 0 012.788 6.162l3.58 6.145a4.519 4.519 0 004.995 2.649zm1.809.136l3.7-6.578-.035-.02A4.511 4.511 0 0014 7.646h4.909a8.875 8.875 0 01-8.159 11.741z","fill":"#fff"}})])
          )
        }
      }
    